import { graphql, useStaticQuery } from 'gatsby'

const useAvatar = () => {
  const { avatar } = useStaticQuery(graphql`
    query {
      avatar: file(relativePath: {eq: "user-placeholder-bg.png"}) {
        publicURL
        childImageSharp{
          fixed(width: 65, quality: 100){
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `);
  return avatar;
}

export default useAvatar;